import { z } from "zod";
export const errorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
    }),
});
export class ApiError extends Error {
    status;
    code;
    constructor(status, code, message) {
        super(message);
        this.name = "ApiError";
        this.status = status;
        this.code = code;
    }
}
